import {read} from "@/api/rest";

const setting = {
    index: async () => await read('/setting/index'),
};

export default setting;